import React, { useState } from 'react';

import { DeleteDialog } from '@lucidhq/lucidium';

import { useDeleteListItem } from '~/impact-measurement/components';
import { t } from '~/utils/i18n';

type DeleteConfirmDialogProps = {
  campaignId?: string;
  creativeId: string;
  onDelete?: (id: any) => void;
  children: ({ handleDelete }: { handleDelete: () => void }) => React.ReactNode;
};

export const DeleteConfirmDialog = ({
  campaignId,
  creativeId,
  onDelete,
  children
}: DeleteConfirmDialogProps) => {
  const [isOpen, setIsOpen] = useState<boolean>();

  const deleteItem = useDeleteListItem(
    `/api/v1/admin/campaigns/${campaignId}/forced-exposure/creatives/${creativeId}`,
    undefined,
    'creative',
    undefined,
    onDelete
  );

  const onClose = (shouldDelete = false) => {
    setIsOpen(!isOpen);

    if (!shouldDelete) return;
    deleteItem(creativeId);
  };

  return (
    <>
      {children({ handleDelete: () => setIsOpen(!isOpen) })}
      <DeleteDialog
        isOpen={isOpen}
        onCancel={() => onClose(false)}
        onClose={() => onClose(false)}
        onDelete={() => onClose(true)}
        closeOnEscPress
      >
        {t('campaignManager.media.deleteConfirm')}
      </DeleteDialog>
    </>
  );
};
